import { useContext, useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AppContext } from '../../App';
import Glynt from '../../api/glynt';

const useGlynt = async (dpid?: string) => {
  const { dataPoolId } = useContext(AppContext);
  const { getAccessTokenSilently } = useAuth0();
  const glynt = useMemo(async () => {
    // console.log("called glynt");
    let token = await getAccessTokenSilently();
    return new Glynt(token, dpid ? dpid : dataPoolId);
  }, [dpid, dataPoolId, getAccessTokenSilently]);

  return glynt;
};

export default useGlynt;
